export const query = `
    query GetCommentsByPostId($postId: ID!, $limit: Int!, $nextToken: String) {
        getComments(postId: $postId, limit: $limit, nextToken: $nextToken) {
        items {
            commentId
            comment
            createdAt
            user {
                userId
                name
                alias
                profilePicture
            }
        }
        nextToken
    }
}`;
export const mutation = `
  mutation AddComment($comment: String!, $postId: ID!, $userId: ID!) {
    addComment(comment: $comment, postId: $postId, userId: $userId) {
      comment {
        commentId
        comment
        createdAt
        postId
        user {
          userId
          name
          alias
          profilePicture
        }
      }
      postCounts {
        commentCount
        isCurrentUserLiked
        likeCount
        postId
      }
    }
  }`;
export const subscription = `
    subscription MySubscription {
  commentSubscription {
    comment {
      action
      comment
      commentId
      createdAt
      isDeleted
      isReported
      postId
      success
      userId
    }
    postCounts {
      postId
      likeCount
      isCurrentUserLiked
      commentCount
    }
  }
}`;
export const subscriptionForLikes = `
    subscription MySubscription {
    likeSubscription {
    like {
      action
      createdAt
      postId
      success
      user {
        alias
        name
        profilePicture
        userId
      }
      userId
    }
    postCounts {
      commentCount
      isCurrentUserLiked
      likeCount
      postId
    }
  }
}`;
